import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Box, Typography } from "@mui/material";
import React from "react";

type TCompanyLogoProps = {
  logo?: string | null | undefined;
};

export const CompanyLogo: FCC<TCompanyLogoProps> = ({ logo }) => {
  return (
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: 1,
        bgcolor: `${black[95]}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        cursor: "pointer",
      }}
    >
      {logo ? (
        <Box
          component="img"
          src={logo}
          alt="ロゴ"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: 2,
          }}
        />
      ) : (
        <Typography variant="body2" color={black[90]}>
          ロゴ
        </Typography>
      )}
    </Box>
  );
};
